import { render, staticRenderFns } from "./LocationCreate.vue?vue&type=template&id=bc524aca&scoped=true"
import script from "./LocationCreate.vue?vue&type=script&lang=js"
export * from "./LocationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc524aca",
  null
  
)

export default component.exports